import dayjs from "dayjs";

/**
 * ISO tarih string'ini "12 Şubat 2026" formatına çevirir (tr-TR locale).
 * @param isoDate - ISO 8601 tarih string
 * @returns Formatlanmış tarih veya boş string
 */
export function formatDateLong(isoDate?: string | null): string {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate);
    return d.toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return isoDate;
  }
}

/**
 * İki ISO tarihini Türkçe (tr-TR) bir başlangıç–bitiş ifadesine çevirir.
 * Bitiş her zaman görünür kılınır:
 *  - Farklı günlerse: "12 Şubat 2026 – 15 Şubat 2026"
 *  - Aynı gün + anlamlı saat varsa: "12 Şubat 2026 · 09:00 – 17:00"
 *  - Aynı gün, saat bilgisi yoksa (tek an): "12 Şubat 2026"
 *  - Yalnızca biri varsa: onu döndürür.
 * @returns Formatlanmış ifade veya boş string
 */
export function formatDateRangeLong(start?: string | null, end?: string | null): string {
  const startLabel = formatDateLong(start);
  const endLabel = formatDateLong(end);
  if (!startLabel) return endLabel;
  if (!endLabel) return startLabel;

  const s = dayjs(start);
  const e = dayjs(end);
  if (s.isValid() && e.isValid() && s.isSame(e, "day")) {
    const st = s.format("HH:mm");
    const et = e.format("HH:mm");
    // Aynı gün: bitiş saatini göster (ör. "00:00 – 23:59"). Saatler anlamsızsa
    // (ikisi de gece yarısı / eşit) tek tarihi göster.
    if (st !== et && !(st === "00:00" && et === "00:00")) {
      return `${startLabel} · ${st} – ${et}`;
    }
    return startLabel;
  }
  return `${startLabel} – ${endLabel}`;
}

/**
 * ISO tarihi "12 Şubat 2026 · 09:00" formatına çevirir. Saat bilgisi anlamsızsa
 * (gece yarısı) yalnız tarih döner — eğitim kartlarında başlangıç saatini
 * göstermek için kullanılır.
 */
export function formatDateTimeLong(isoDate?: string | null): string {
  const dateLabel = formatDateLong(isoDate);
  if (!dateLabel) return "";
  const d = dayjs(isoDate);
  if (!d.isValid()) return dateLabel;
  const time = d.format("HH:mm");
  return time === "00:00" ? dateLabel : `${dateLabel} · ${time}`;
}
